import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificheChat } from '../api/notifiche';
import { MdArrowBack, MdCloudDownload, MdSearch } from 'react-icons/md';
import ContactAvatar from '../mobile/ContactAvatar';
import { selectContact } from '../store/messageSlice';
// Sotto il nome il numero vero della persona, come su WhatsApp; nei gruppi e
// senza numero resta il collegamento ai dettagli.
export function sottotitolo(contatto, attivo) {
  const numero = !contatto.is_group && (contatto.phone_number || '').startsWith('+') ? contatto.phone_number : '';
  return [attivo ? '' : 'Sola lettura', numero || (attivo ? 'Account collegato · Dettagli' : 'Dettagli')].filter(Boolean).join(' · ');
}

// Le notifiche di questa chat: come su WhatsApp (silenziata lì o no), sempre, mai.
function SceltaNotifiche({ contatto }) {
  const [scelta, setScelta] = useState(contatto.notifiche || '');
  const [silenziata, setSilenziata] = useState(!!contatto.silenziata);
  const [errore, setErrore] = useState('');
  const cambia = async valore => {
    setScelta(valore); setErrore('');
    try { const { data } = await notificheChat(contatto.id, valore); setSilenziata(data.silenziata); }
    catch (_) { setErrore('Non salvato, riprova.'); }
  };
  return <label className="scelta-notifiche">Notifiche
    <select value={scelta} onChange={e => cambia(e.target.value)}>
      <option value="">Come su WhatsApp{scelta === '' ? (silenziata ? ' (silenziata)' : ' (attive)') : ''}</option>
      <option value="sempre">Sempre</option>
      <option value="mai">Mai (silenziata)</option>
    </select>{errore && <span role="alert">{errore}</span>}</label>;
}

export default function ChatHeader({ selectedContact, connectionLabel, dispatch, activeSession, handleFetchFromWA, fetching, onCerca }) {
  const navigate = useNavigate();
  return <header className="conversation-header"><button className="icon-button chat-back" onClick={() => { dispatch(selectContact(null)); navigate('/chat', { replace: true }); }} aria-label="Torna alle chat"><MdArrowBack size={24} /></button><ContactAvatar contact={selectedContact} /><details key={selectedContact.id}><summary><strong>{selectedContact.name}</strong><span>{sottotitolo(selectedContact, !!activeSession)}</span></summary><div className="dettagli-chat"><p>{connectionLabel(selectedContact)}</p>{selectedContact.connection && <SceltaNotifiche contatto={selectedContact} />}</div></details>{onCerca && <button className="icon-button" aria-label="Cerca nella chat" onClick={onCerca}><MdSearch size={23} /></button>}{activeSession && <button className="icon-button" aria-label="Recupera messaggi da WhatsApp" title="Recupera messaggi da WhatsApp" disabled={fetching} onClick={() => handleFetchFromWA(100)}><MdCloudDownload size={23} /></button>}</header>;
}

